import TabToggle from 'components/commons/tab-toogle'
import { Button, InlineError, Input } from 'avo-ui'
import Select from 'components/commons/select'
import icTrash from 'assets/images/ic-trash.svg'
import icUpload from 'assets/images/ic-upload.svg'
import clsx from 'clsx'
import { FormUploadImage } from 'components/product/product-create/general-info/FormUploadImage'
import { OtherImages } from 'components/product/product-create/general-info/OtherImages'

export const GeneralInfo = ({
    sectionRef,
    productDetail,
    options,
    onSearchOptions,
    onChangeForm,
    errorForm,
    showFormUpload,
    onShowFormUpload,
    onHideFormUpload,
    uploadDetail,
    onChangeUploadDetail,
    onDeleteMainImage,
    onChangeOtherImages,
    errorFormUpload,
    onSubmitUpload,
}) => {
    return (
        <div ref={sectionRef}>
            <TabToggle
                title={'General Info'}
                content={
                    <div className={'flex space-x-16'}>
                        <div className={'flex-1 flex-col space-y-5'}>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90 required'}>Nama Produk</div>
                                <Input
                                    className={'flex-1'}
                                    name={'name'}
                                    placeholder={'Masukkan nama produk'}
                                    value={productDetail?.name}
                                    onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                                />
                                <InlineError className='mt-2' message={errorForm?.name} />
                            </div>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90 required'}>Kategori Produk</div>
                                <Select
                                    name={'category_ids'}
                                    className={'flex-1'}
                                    optionsClassName={'max-h-40'}
                                    placeholder={'Pilih kategori produk'}
                                    options={options?.category}
                                    value={productDetail?.category_ids}
                                    searchable
                                    isMultiple
                                    onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                                    onSearch={(value) => onSearchOptions('category', value)}
                                />
                                <InlineError className='mt-2' message={errorForm?.category_ids} />
                            </div>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90 required'}>Pilih Brand</div>
                                <Select
                                    name={'brand_id'}
                                    className={'flex-1'}
                                    optionsClassName={'max-h-40'}
                                    placeholder={'Pilih brand'}
                                    options={options?.brand}
                                    value={productDetail?.brand_id}
                                    searchable
                                    onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                                    onSearch={(value) => onSearchOptions('brand', value)}
                                />
                                <InlineError className='mt-2' message={errorForm?.brand_id} />
                            </div>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90'}>Tipe Produk</div>
                                <Select
                                    name={'type_ids'}
                                    className={'flex-1'}
                                    optionsClassName={'max-h-40'}
                                    placeholder={'Pilih tipe produk'}
                                    options={options?.product_type}
                                    value={productDetail?.type_ids}
                                    searchable
                                    isMultiple
                                    onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                                    onSearch={(value) => onSearchOptions('product_type', value)}
                                />
                                <InlineError className='mt-2' message={errorForm?.type_ids} />
                            </div>
                        </div>
                        <div className={'flex-1 flex-col space-y-5'}>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90 required'}>Foto Produk</div>
                                <div
                                    className={`flex ${productDetail?.main_image?.url?.base64 || productDetail?.main_image?.url ? 'items-center space-x-3' : 'flex-col space-y-3'}`}
                                >
                                    {(productDetail?.main_image?.url?.base64 || productDetail?.main_image?.url) && (
                                        <div className={'relative w-fit'}>
                                            <img
                                                src={
                                                    productDetail?.main_image?.url?.base64 ||
                                                    productDetail?.main_image?.url
                                                }
                                                className={clsx('w-48 h-48 border border-neutral-30 rounded-md')}
                                                alt={'file-image'}
                                            />
                                            <Button
                                                type={'outline'}
                                                icon={icTrash}
                                                className={clsx('absolute top-2 right-2 !rounded-full')}
                                                onClick={onDeleteMainImage}
                                            />
                                            <InlineError className='mt-2' message={errorForm?.main_image} />
                                        </div>
                                    )}
                                    <div
                                        className={
                                            'avo__button w-fit bg-blue-5 border border-blue-20 hover:bg-blue-20 space-x-3 px-8'
                                        }
                                        onClick={() => onShowFormUpload('main-image')}
                                    >
                                        <img src={icUpload} className={'w-4'} alt={'ic-upload'} />
                                        <div className={'font-semibold text-blue-90'}>Upload</div>
                                    </div>
                                    {!(productDetail?.main_image?.url?.base64 || productDetail?.main_image?.url) && (
                                        <InlineError className='mt-2' message={errorForm?.main_image} />
                                    )}
                                </div>
                            </div>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90'}>Foto Lainnya</div>
                                <OtherImages
                                    data={productDetail?.other_images}
                                    onShowFormUpload={() => onShowFormUpload('other-images')}
                                    onChange={onChangeOtherImages}
                                    maxImage={10}
                                />
                            </div>
                        </div>
                    </div>
                }
            />
            {showFormUpload && (
                <FormUploadImage
                    show={showFormUpload}
                    onHideForm={onHideFormUpload}
                    dataUpload={uploadDetail}
                    onChangeForm={onChangeUploadDetail}
                    errorForm={errorFormUpload}
                    onSubmit={onSubmitUpload}
                />
            )}
        </div>
    )
}
